import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminProductStatus } from '../../enums/admin-product-status';
import { AdminProductStatusPipe } from '../../pipes/admin-product-status.pipe';

@Component({
  selector: 'app-admin-product-status',
  imports: [CommonModule, AdminProductStatusPipe],
  templateUrl: './admin-product-status.component.html',
  styleUrl: './admin-product-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminProductStatusComponent {
  public readonly status = input.required<AdminProductStatus>();
}
